export default {
  zh: {
      // SEO Meta
      pageTitle: 'Midjourney - 灵活、细腻且充满活力的图像生成',
      pageDescription: 'Midjourney 是由独立研究实验室推出的旗舰级 AI 图像模型，以极致艺术审美与光影质感著称。立即在 微鲤AI 免费体验。',
      shortDescription: '灵活、细腻且充满活力的图像生成',
      pageKeywords: 'Midjourney, AI图像生成, 艺术创作, 光影质感, 文字渲染, 超写实人像, 微鲤AI',
      ogTitle: 'Midjourney AI 图像生成器 | 微鲤AI',
      ogDescription: 'Midjourney 旗舰级AI图像模型，极致艺术审美与光影质感',
      twitterTitle: 'Midjourney - 灵活、细腻且充满活力的图像生成',
      twitterDescription: '体验 Midjourney 的强大图像生成能力，极致艺术感与细节表现',

      // Generator Section
      generatorTitle: 'Midjourney 图像生成器',
      generatorSubtitle: 'Midjourney 是由独立研究实验室 Midjourney Inc. 推出的最新一代旗舰级 AI 图像模型。它在保持业界领先的艺术性和光影质感的同时，大幅提升了画面的连贯性（Coherence）、肢体解剖学的准确性以及文字渲染能力。该模型以其对自然语言的细腻理解、逼真的皮肤纹理表现以及独特的个性化模型微调功能而闻名，是全球数字艺术家、摄影师及高端设计领域的首选工具。快来 微鲤AI 体验 Midjourney 带来的极致视觉震撼吧！',

      // Core Features
      coreFeaturesTitle: 'Midjourney 核心功能',
      coreFeaturesSubtitle: '探索 Midjourney 的强大功能，开启专业级 AI 图像创作之旅',

      feature1Title: '精准文字渲染',
      feature1Desc: '显著提升了在图像中生成准确文本的能力。通过使用双引号（" "）将文字包裹，模型能够生成拼写正确、字体风格与画面完美融合的标题、霓虹灯牌或标签，解决了以往 AI 难以处理具体字符的痛点。',
      feature1Alt: 'Midjourney 精准文字渲染示例',

      feature2Title: '超写实人像与解剖学修正',
      feature2Desc: '针对 AI 绘画中常见的手部和肢体错误进行了深度优化。v6.1 能生成解剖结构准确的手指、四肢，并极大地增强了皮肤纹理的真实感，包括毛孔、皱纹和光线在皮肤上的次表面散射效果，达到商业摄影级别。',
      feature2Alt: 'Midjourney 超写实人像示例',

      feature3Title: '个性化模型微调',
      feature3Desc: '模型会根据用户的历史评分和偏好，学习并建立用户专属的审美模型。这意味着每个人生成的图片都将带有独特的个人艺术风格，而不仅仅是通用的"AI味"。',
      feature3Alt: 'Midjourney 个性化微调示例',

      feature4Title: '智能纹理增强与 2x 放大',
      feature4Desc: '配备了全新的 Subtle 和 Creative 放大器。在将图像分辨率放大 2 倍的同时，模型会智能补充原本不存在的微小细节（如织物纤维、远处树叶），使 4K 输出成为可能，且不再出现过度平滑或伪影。',
      feature4Alt: 'Midjourney 智能放大示例',

      // How to Use
      howToUseTitle: '如何在 微鲤AI 上使用 Midjourney',
      howToUseSubtitle: '简单三步，开始创作',

      step1Title: '选择模型',
      step1Description: '在 AI 图像工具中选择 Midjourney 模型',

      step2Title: '输入内容',
      step2Description: '输入提示词或上传参考图像',

      step3Title: '生成图像',
      step3Description: '点击生成按钮，等待并下载生成的图像',

      // YouTube Section
      youtubeTitle: '关于 Midjourney AI 图像模型的 YouTube 视频',

      // X Posts Section
      xPostsTitle: '关于 Midjourney AI 图像模型的 X 帖子',

      // Explore Models
      exploreModelsTitle: '探索 微鲤AI 上的其他图像模型',
      model1Title: 'Nano Banana Pro',
      model2Title: 'Seedream 4.5',
      model3Title: 'Dreamina 4',
      model4Title: 'Wan 2.5',

      // FAQ
      faqTitle: '常见问题解答',

      faq1Question: 'Midjourney 是什么？',
      faq1Answer: 'Midjourney是目前公认综合效果最强的 AI 图像生成模型之一，以其富有艺术感的构图、逼真的光影效果和强大的细节表现力而著称。',

      faq2Question: '它主要能做什么？',
      faq2Answer: '它能生成照片级写实图像、各种风格的插画、游戏资产、网页设计素材，并且在 v6.1 版本中，生成带文字的图片和保持人物一致性的能力得到了巨大提升。',

      faq3Question: '在 微鲤AI 上使用是免费的吗？',
      faq3Answer: 'Midjourney 官方服务是完全付费的。在 微鲤AI 上，我们提供有限的免费试用额度，如需高频使用或商用生成，建议订阅我们的会员计划以获取更稳定的通道。',

      faq4Question: '生成图片的质量如何？',
      faq4Answer: '质量极高。Midjourney默认生成 1024x1024 分辨率，通过其内置的 Upscaler（放大器），可以输出 2048x2048 甚至更高的高清图，且细节丰富，无模糊感。',

      faq5Question: '它和 Wan AI、Seedream 4.5 有什么区别？',
      faq5Answer: '相比 Wan AI 或 Seedream 4.5 等模型，Midjourney 最大的优势在于极致的艺术审美与光影质感。虽然 Seedream 在多图一致性控制上更精准，Nano Banana Pro 生成速度更快，但 Midjourney 能在无需复杂提示词的情况下，直接生成具有电影级构图、丰富细节和强烈视觉冲击力的图像，是追求高品质艺术创作的首选。',

      faq6Question: '我可以将生成的图片用于商业用途吗？',
      faq6Answer: '如果您是 微鲤AI 的付费订阅用户，您通常拥有生成图片的商业使用权。具体请参考 微鲤AI 的服务条款。',

      // CTA Section
      ctaTitle: '立即体验 Midjourney',
      ctaDescription: '免费使用顶级AI图像生成模型',
      ctaButton: '开始创作',
      ctaDisclaimer: '无需信用卡，立即开始',
  },
  en: {
      // SEO Meta
      pageTitle: 'Midjourney - Flexible, detailed and vibrant image generation',
      pageDescription: 'Midjourney is a flagship AI image model from an independent research lab, renowned for its artistic aesthetics and lighting quality. Try it free on 微鲤AI.',
      shortDescription: 'Flexible, detailed and vibrant image generation',
      pageKeywords: 'Midjourney, AI image generation, artistic creation, lighting quality, text rendering, hyperrealistic portraits, 微鲤AI',
      ogTitle: 'Midjourney AI Image Generator | 微鲤AI',
      ogDescription: 'Midjourney flagship AI image model with ultimate artistic aesthetics and lighting quality',
      twitterTitle: 'Midjourney - Flexible, detailed and vibrant image generation',
      twitterDescription: 'Experience Midjourney powerful image generation with ultimate artistic sense and detail expression',

      // Generator Section
      generatorTitle: 'Midjourney Image Generator',
      generatorSubtitle: 'Midjourney is the latest generation flagship AI image model from independent research lab Midjourney Inc. While maintaining industry-leading artistry and lighting quality, it has significantly improved image coherence, anatomical accuracy of limbs, and text rendering capabilities. The model is renowned for its nuanced understanding of natural language, realistic skin texture rendering, and unique personalization fine-tuning features, making it the preferred tool for digital artists, photographers, and high-end design professionals worldwide. Experience the ultimate visual impact of Midjourney on 微鲤AI!',

      // Core Features
      coreFeaturesTitle: 'Midjourney Core Features',
      coreFeaturesSubtitle: 'Explore the powerful features of Midjourney and start your professional AI image creation journey',

      feature1Title: 'Precise Text Rendering',
      feature1Desc: 'Significantly improved ability to generate accurate text in images. By wrapping text in double quotes (" "), the model can generate correctly spelled titles, neon signs, or labels with font styles that perfectly blend with the image, solving the pain point of AI struggling with specific characters.',
      feature1Alt: 'Midjourney precise text rendering example',

      feature2Title: 'Hyperrealistic Portraits & Anatomical Correction',
      feature2Desc: 'Deep optimization for common hand and limb errors in AI painting. v6.1 can generate anatomically accurate fingers and limbs, and greatly enhanced skin texture realism, including pores, wrinkles, and subsurface scattering effects of light on skin, reaching commercial photography level.',
      feature2Alt: 'Midjourney hyperrealistic portrait example',

      feature3Title: 'Personalization Fine-tuning',
      feature3Desc: 'The model learns and builds a user-specific aesthetic model based on user history ratings and preferences. This means images generated by each person will carry their unique personal artistic style, rather than just generic "AI flavor".',
      feature3Alt: 'Midjourney personalization example',

      feature4Title: 'Intelligent Texture Enhancement & 2x Upscaling',
      feature4Desc: 'Equipped with new Subtle and Creative upscalers. While doubling the image resolution, the model intelligently adds small details that did not originally exist (such as fabric fibers, distant leaves), making 4K output possible without over-smoothing or artifacts.',
      feature4Alt: 'Midjourney intelligent upscaling example',

      // How to Use
      howToUseTitle: 'How to Use Midjourney on 微鲤AI',
      howToUseSubtitle: 'Get started in just three steps',

      step1Title: 'Select Model',
      step1Description: 'Choose Midjourney in the AI Image tools',

      step2Title: 'Enter Content',
      step2Description: 'Enter prompts or upload reference images',

      step3Title: 'Generate Image',
      step3Description: 'Click generate and download your image',

      // YouTube Section
      youtubeTitle: 'YouTube Videos About Midjourney AI Image Model',

      // X Posts Section
      xPostsTitle: 'X Posts About Midjourney AI Image Model',

      // Explore Models
      exploreModelsTitle: 'Explore Other Image Models on 微鲤AI',
      model1Title: 'Nano Banana Pro',
      model2Title: 'Seedream 4.5',
      model3Title: 'Dreamina 4',
      model4Title: 'Wan 2.5',

      // FAQ
      faqTitle: 'Frequently Asked Questions',

      faq1Question: 'What is Midjourney?',
      faq1Answer: 'Midjourney is recognized as one of the most comprehensive AI image generation models, renowned for its artistic composition, realistic lighting effects, and powerful detail expression.',

      faq2Question: 'What can it do?',
      faq2Answer: 'It can generate photo-realistic images, illustrations in various styles, game assets, web design materials, and in v6.1, the ability to generate images with text and maintain character consistency has been greatly improved.',

      faq3Question: 'Is it free to use on 微鲤AI?',
      faq3Answer: 'Midjourney official service is fully paid. On 微鲤AI, we offer limited free trial credits. For high-frequency use or commercial generation, we recommend subscribing to our membership plan for more stable access.',

      faq4Question: 'What is the image quality?',
      faq4Answer: 'Extremely high quality. Midjourney generates 1024x1024 resolution by default, and through its built-in Upscaler, can output 2048x2048 or higher HD images with rich details and no blur.',

      faq5Question: 'How is it different from Wan AI or Seedream 4.5?',
      faq5Answer: 'Compared to models like Wan AI or Seedream 4.5, Midjourney greatest advantage is its ultimate artistic aesthetics and lighting quality. While Seedream is more precise in multi-image consistency control and Nano Banana Pro is faster, Midjourney can directly generate images with cinematic composition, rich details, and strong visual impact without complex prompts, making it the first choice for high-quality artistic creation.',

      faq6Question: 'Can I use generated images commercially?',
      faq6Answer: 'If you are a paid subscriber of 微鲤AI, you typically have commercial usage rights for generated images. Please refer to 微鲤AI terms of service for details.',

      // CTA Section
      ctaTitle: 'Try Midjourney Now',
      ctaDescription: 'Use the top-tier AI image generation model for free',
      ctaButton: 'Start Creating',
      ctaDisclaimer: 'No credit card required',
  },
  ja: {
      pageTitle: 'Midjourney - 柔軟で詳細、かつ鮮やかな画像生成',
      shortDescription: '柔軟で詳細、かつ鮮やかな画像生成',
      generatorTitle: 'Midjourney 画像ジェネレーター',
      generatorSubtitle: 'Midjourneyは独立研究ラボMidjourney Inc.による最新世代のフラッグシップAI画像モデルです。業界をリードする芸術性と光影の質感を維持しながら、画像の一貫性、解剖学的正確性、テキストレンダリング能力を大幅に向上させています。',
      coreFeaturesTitle: 'Midjourney コア機能',
      coreFeaturesSubtitle: 'Midjourneyの強力な機能を探索',
      feature1Title: '精密なテキストレンダリング',
      feature1Desc: '画像内に正確なテキストを生成する能力が大幅に向上。ダブルクォーテーションでテキストを囲むことで、正しいスペル、画像と完璧に調和するフォントスタイルのタイトル、ネオンサイン、ラベルを生成できます。',
      feature2Title: '超写実的なポートレートと解剖学的修正',
      feature2Desc: 'AI絵画で一般的な手や四肢のエラーに対する深い最適化。v6.1は解剖学的に正確な指と四肢を生成し、毛穴、しわ、皮膚上の光のサブサーフェススキャッタリング効果を含む皮膚テクスチャのリアリズムを大幅に向上させています。',
      feature3Title: 'パーソナライゼーション微調整',
      feature3Desc: 'モデルはユーザーの履歴評価と好みに基づいて、ユーザー固有の美的モデルを学習・構築します。これにより、各人が生成する画像には独自の個人的な芸術スタイルが反映されます。',
      feature4Title: 'インテリジェントテクスチャ強化と2x拡大',
      feature4Desc: '新しいSubtleとCreativeアップスケーラーを搭載。画像解像度を2倍にしながら、元々存在しなかった細かいディテールをインテリジェントに追加し、4K出力を可能にします。',
      howToUseTitle: 'WeryAIでMidjourneyを使用する方法',
      step1Title: 'モデルを選択',
      step1Description: 'AI画像ツールでMidjourneyを選択',
      step2Title: 'コンテンツを入力',
      step2Description: 'プロンプトを入力するか参照画像をアップロード',
      step3Title: '画像を生成',
      step3Description: '生成をクリックして画像をダウンロード',
      youtubeTitle: 'Midjourney AI画像モデルに関するYouTube動画',
      xPostsTitle: 'Midjourney AI画像モデルに関するXの投稿',
      exploreModelsTitle: 'WeryAIの他の画像モデルを探索',
      model1Title: 'Nano Banana Pro',
      model2Title: 'Seedream 4.5',
      model3Title: 'Dreamina 4',
      model4Title: 'Wan 2.5',
      faqTitle: 'よくある質問',
      faq1Question: 'Midjourneyとは？',
      faq1Answer: 'Midjourneyは最も包括的なAI画像生成モデルの1つとして認められており、芸術的な構図、リアルな照明効果、強力なディテール表現で知られています。',
      faq2Question: '何ができますか？',
      faq2Answer: 'フォトリアリスティックな画像、様々なスタイルのイラスト、ゲームアセット、ウェブデザイン素材を生成でき、v6.1ではテキスト付き画像の生成とキャラクターの一貫性維持能力が大幅に向上しています。',
      faq3Question: 'WeryAIで無料で使えますか？',
      faq3Answer: 'Midjourney公式サービスは完全有料です。WeryAIでは限定的な無料トライアルクレジットを提供しています。高頻度使用や商用生成には、より安定したアクセスのためにメンバーシッププランへの登録をお勧めします。',
      faq4Question: '画像品質はどうですか？',
      faq4Answer: '非常に高品質です。Midjourneyはデフォルトで1024x1024解像度を生成し、内蔵のUpscalerを通じて2048x2048以上のHD画像を出力でき、詳細が豊富でぼやけがありません。',
      faq5Question: 'Wan AIやSeedream 4.5との違いは？',
      faq5Answer: 'Wan AIやSeedream 4.5などのモデルと比較して、Midjourneyの最大の利点は究極の芸術的美学と照明品質です。複雑なプロンプトなしで、映画のような構図、豊富なディテール、強い視覚的インパクトを持つ画像を直接生成できます。',
      faq6Question: '商用利用できますか？',
      faq6Answer: 'WeryAIの有料会員であれば、生成された画像の商用利用権を通常持っています。詳細はWeryAIの利用規約をご参照ください。',
      ctaTitle: '今すぐMidjourneyを試す',
      ctaDescription: 'トップクラスのAI画像生成モデルを無料で使用',
      ctaButton: '創作を開始',
      ctaDisclaimer: 'クレジットカード不要',
  },
  ko: {
      pageTitle: 'Midjourney - 유연하고 섬세하며 생동감 넘치는 이미지 생성',
      shortDescription: '유연하고 섬세하며 생동감 넘치는 이미지 생성',
      generatorTitle: 'Midjourney 이미지 생성기',
      generatorSubtitle: 'Midjourney는 독립 연구소 Midjourney Inc.의 최신 세대 플래그십 AI 이미지 모델입니다. 업계를 선도하는 예술성과 조명 품질을 유지하면서 이미지 일관성, 해부학적 정확성, 텍스트 렌더링 기능을 크게 향상시켰습니다.',
      coreFeaturesTitle: 'Midjourney 핵심 기능',
      feature1Title: '정밀한 텍스트 렌더링',
      feature1Desc: '이미지에서 정확한 텍스트를 생성하는 능력이 크게 향상되었습니다. 큰따옴표로 텍스트를 감싸면 올바른 철자, 이미지와 완벽하게 조화되는 폰트 스타일의 제목, 네온 사인, 라벨을 생성할 수 있습니다.',
      feature2Title: '초현실적 인물과 해부학적 수정',
      feature2Desc: 'AI 그림에서 흔한 손과 사지 오류에 대한 심층 최적화. v6.1은 해부학적으로 정확한 손가락과 사지를 생성하고, 모공, 주름, 피부 위의 빛의 서브서피스 산란 효과를 포함한 피부 텍스처 사실감을 크게 향상시켰습니다.',
      feature3Title: '개인화 미세 조정',
      feature3Desc: '모델은 사용자의 기록 평가와 선호도를 기반으로 사용자별 미적 모델을 학습하고 구축합니다. 이는 각 사람이 생성하는 이미지에 고유한 개인 예술 스타일이 반영됨을 의미합니다.',
      feature4Title: '지능형 텍스처 향상 및 2x 업스케일링',
      feature4Desc: '새로운 Subtle 및 Creative 업스케일러가 탑재되었습니다. 이미지 해상도를 2배로 높이면서 원래 존재하지 않던 작은 디테일을 지능적으로 추가하여 4K 출력이 가능합니다.',
      howToUseTitle: 'WeryAI에서 Midjourney 사용 방법',
      step1Title: '모델 선택',
      step1Description: 'AI 이미지 도구에서 Midjourney 선택',
      step2Title: '콘텐츠 입력',
      step2Description: '프롬프트 입력 또는 참조 이미지 업로드',
      step3Title: '이미지 생성',
      step3Description: '생성을 클릭하고 이미지 다운로드',
      youtubeTitle: 'Midjourney AI 이미지 모델 관련 YouTube 동영상',
      xPostsTitle: 'Midjourney AI 이미지 모델 관련 X 게시물',
      exploreModelsTitle: 'WeryAI의 다른 이미지 모델 탐색',
      model1Title: 'Nano Banana Pro',
      model2Title: 'Seedream 4.5',
      model3Title: 'Dreamina 4',
      model4Title: 'Wan 2.5',
      faqTitle: '자주 묻는 질문',
      faq1Question: 'Midjourney란?',
      faq1Answer: 'Midjourney는 가장 포괄적인 AI 이미지 생성 모델 중 하나로 인정받으며, 예술적인 구도, 사실적인 조명 효과, 강력한 디테일 표현력으로 유명합니다.',
      faq2Question: '무엇을 할 수 있나요?',
      faq2Answer: '포토리얼리스틱 이미지, 다양한 스타일의 일러스트레이션, 게임 에셋, 웹 디자인 소재를 생성할 수 있으며, v6.1에서는 텍스트가 포함된 이미지 생성과 캐릭터 일관성 유지 능력이 크게 향상되었습니다.',
      faq3Question: 'WeryAI에서 무료로 사용할 수 있나요?',
      faq3Answer: 'Midjourney 공식 서비스는 완전 유료입니다. WeryAI에서는 제한된 무료 체험 크레딧을 제공합니다. 고빈도 사용이나 상업용 생성을 위해서는 더 안정적인 접근을 위해 멤버십 플랜 가입을 권장합니다.',
      faq4Question: '이미지 품질은 어떤가요?',
      faq4Answer: '매우 높은 품질입니다. Midjourney는 기본적으로 1024x1024 해상도를 생성하고, 내장 Upscaler를 통해 2048x2048 이상의 HD 이미지를 출력할 수 있으며 디테일이 풍부하고 흐림이 없습니다.',
      faq5Question: 'Wan AI나 Seedream 4.5와 어떻게 다른가요?',
      faq5Answer: 'Wan AI나 Seedream 4.5 같은 모델과 비교했을 때, Midjourney의 가장 큰 장점은 궁극적인 예술적 미학과 조명 품질입니다. 복잡한 프롬프트 없이도 영화 같은 구도, 풍부한 디테일, 강한 시각적 충격을 가진 이미지를 직접 생성할 수 있습니다.',
      faq6Question: '상업적으로 사용할 수 있나요?',
      faq6Answer: 'WeryAI의 유료 구독자라면 일반적으로 생성된 이미지의 상업적 사용권을 가집니다. 자세한 내용은 微鲤AI 이용약관을 참조하세요.',
      ctaTitle: '지금 Midjourney 체험하기',
      ctaDescription: '최상위 AI 이미지 생성 모델을 무료로 사용',
      ctaButton: '창작 시작',
      ctaDisclaimer: '신용카드 불필요',
  },
  es: {
      pageTitle: 'Midjourney - Generación de imágenes flexible, detallada y vibrante',
      shortDescription: 'Generación de imágenes flexible, detallada y vibrante',
      generatorTitle: 'Generador de Imágenes Midjourney',
      generatorSubtitle: 'Midjourney es el modelo de imagen IA insignia de última generación del laboratorio de investigación independiente Midjourney Inc. Manteniendo la artística y calidad de iluminación líder en la industria, ha mejorado significativamente la coherencia de imagen, precisión anatómica y capacidades de renderizado de texto.',
      coreFeaturesTitle: 'Características Principales de Midjourney',
      coreFeaturesSubtitle: 'Explora las poderosas funciones de Midjourney',
      feature1Title: 'Renderizado de Texto Preciso',
      feature1Desc: 'Capacidad significativamente mejorada para generar texto preciso en imágenes. Envolviendo texto en comillas dobles, el modelo puede generar títulos, letreros de neón o etiquetas correctamente escritos con estilos de fuente que se mezclan perfectamente con la imagen.',
      feature2Title: 'Retratos Hiperrealistas y Corrección Anatómica',
      feature2Desc: 'Optimización profunda para errores comunes de manos y extremidades en la pintura IA. v6.1 puede generar dedos y extremidades anatómicamente precisos, y mejoró enormemente el realismo de la textura de la piel.',
      feature3Title: 'Ajuste Fino de Personalización',
      feature3Desc: 'El modelo aprende y construye un modelo estético específico del usuario basado en las calificaciones e preferencias del historial del usuario. Esto significa que las imágenes generadas por cada persona tendrán su estilo artístico personal único.',
      feature4Title: 'Mejora Inteligente de Textura y Escalado 2x',
      feature4Desc: 'Equipado con nuevos escaladores Subtle y Creative. Mientras duplica la resolución de la imagen, el modelo agrega inteligentemente pequeños detalles que originalmente no existían, haciendo posible la salida 4K.',
      howToUseTitle: 'Cómo Usar Midjourney en 微鲤AI',
      step1Title: 'Seleccionar Modelo',
      step1Description: 'Elige Midjourney en las herramientas de imagen IA',
      step2Title: 'Ingresar Contenido',
      step2Description: 'Ingresa prompts o sube imágenes de referencia',
      step3Title: 'Generar Imagen',
      step3Description: 'Haz clic en generar y descarga tu imagen',
      youtubeTitle: 'Videos de YouTube sobre el Modelo de Imagen IA Midjourney',
      xPostsTitle: 'Publicaciones de X sobre el Modelo de Imagen IA Midjourney',
      exploreModelsTitle: 'Explora Otros Modelos de Imagen en 微鲤AI',
      model1Title: 'Nano Banana Pro',
      model2Title: 'Seedream 4.5',
      model3Title: 'Dreamina 4',
      model4Title: 'Wan 2.5',
      faqTitle: 'Preguntas Frecuentes',
      faq1Question: '¿Qué es Midjourney?',
      faq1Answer: 'Midjourney es reconocido como uno de los modelos de generación de imágenes IA más completos, famoso por su composición artística, efectos de iluminación realistas y poderosa expresión de detalles.',
      faq2Question: '¿Qué puede hacer?',
      faq2Answer: 'Puede generar imágenes fotorrealistas, ilustraciones en varios estilos, assets de juegos, materiales de diseño web, y en v6.1, la capacidad de generar imágenes con texto y mantener consistencia de personajes ha mejorado enormemente.',
      faq3Question: '¿Es gratis en 微鲤AI?',
      faq3Answer: 'El servicio oficial de Midjourney es completamente de pago. En 微鲤AI, ofrecemos créditos de prueba gratuitos limitados. Para uso de alta frecuencia o generación comercial, recomendamos suscribirse a nuestro plan de membresía.',
      faq4Question: '¿Cuál es la calidad de imagen?',
      faq4Answer: 'Calidad extremadamente alta. Midjourney genera resolución 1024x1024 por defecto, y a través de su Upscaler incorporado, puede producir imágenes HD de 2048x2048 o superiores con detalles ricos y sin desenfoque.',
      faq5Question: '¿En qué se diferencia de Wan AI o Seedream 4.5?',
      faq5Answer: 'Comparado con modelos como Wan AI o Seedream 4.5, la mayor ventaja de Midjourney es su estética artística definitiva y calidad de iluminación. Puede generar directamente imágenes con composición cinematográfica, detalles ricos e impacto visual fuerte sin prompts complejos.',
      faq6Question: '¿Puedo usar las imágenes comercialmente?',
      faq6Answer: 'Si eres suscriptor de pago de 微鲤AI, normalmente tienes derechos de uso comercial para las imágenes generadas. Consulta los términos de servicio de 微鲤AI para más detalles.',
      ctaTitle: 'Prueba Midjourney Ahora',
      ctaDescription: 'Usa el modelo de generación de imágenes IA de primer nivel gratis',
      ctaButton: 'Comenzar a Crear',
      ctaDisclaimer: 'Sin tarjeta de crédito requerida',
  },
  fr: {
      pageTitle: 'Midjourney - Génération d\'images flexible, détaillée et vibrante',
      shortDescription: 'Génération d\'images flexible, détaillée et vibrante',
      generatorTitle: 'Générateur d\'Images Midjourney',
      generatorSubtitle: 'Midjourney est le modèle d\'image IA phare de dernière génération du laboratoire de recherche indépendant Midjourney Inc. Tout en maintenant l\'artistique et la qualité d\'éclairage leaders de l\'industrie, il a considérablement amélioré la cohérence d\'image, la précision anatomique et les capacités de rendu de texte.',
      coreFeaturesTitle: 'Fonctionnalités Principales de Midjourney',
      coreFeaturesSubtitle: 'Explorez les puissantes fonctionnalités de Midjourney',
      feature1Title: 'Rendu de Texte Précis',
      feature1Desc: 'Capacité significativement améliorée à générer du texte précis dans les images. En entourant le texte de guillemets doubles, le modèle peut générer des titres, enseignes au néon ou étiquettes correctement orthographiés avec des styles de police qui se fondent parfaitement avec l\'image.',
      feature2Title: 'Portraits Hyperréalistes et Correction Anatomique',
      feature2Desc: 'Optimisation approfondie pour les erreurs courantes de mains et membres dans la peinture IA. v6.1 peut générer des doigts et membres anatomiquement précis, et a grandement amélioré le réalisme de la texture de la peau.',
      feature3Title: 'Ajustement Fin de Personnalisation',
      feature3Desc: 'Le modèle apprend et construit un modèle esthétique spécifique à l\'utilisateur basé sur les évaluations et préférences historiques de l\'utilisateur. Cela signifie que les images générées par chaque personne porteront leur style artistique personnel unique.',
      feature4Title: 'Amélioration Intelligente de Texture et Agrandissement 2x',
      feature4Desc: 'Équipé de nouveaux upscalers Subtle et Creative. Tout en doublant la résolution de l\'image, le modèle ajoute intelligemment de petits détails qui n\'existaient pas à l\'origine, rendant la sortie 4K possible.',
      howToUseTitle: 'Comment Utiliser Midjourney sur 微鲤AI',
      step1Title: 'Sélectionner le Modèle',
      step1Description: 'Choisissez Midjourney dans les outils d\'image IA',
      step2Title: 'Saisir le Contenu',
      step2Description: 'Entrez des prompts ou téléchargez des images de référence',
      step3Title: 'Générer l\'Image',
      step3Description: 'Cliquez sur générer et téléchargez votre image',
      youtubeTitle: 'Vidéos YouTube sur le Modèle d\'Image IA Midjourney',
      xPostsTitle: 'Publications X sur le Modèle d\'Image IA Midjourney',
      exploreModelsTitle: 'Explorez d\'Autres Modèles d\'Image sur 微鲤AI',
      model1Title: 'Nano Banana Pro',
      model2Title: 'Seedream 4.5',
      model3Title: 'Dreamina 4',
      model4Title: 'Wan 2.5',
      faqTitle: 'Questions Fréquemment Posées',
      faq1Question: 'Qu\'est-ce que Midjourney?',
      faq1Answer: 'Midjourney est reconnu comme l\'un des modèles de génération d\'images IA les plus complets, célèbre pour sa composition artistique, ses effets d\'éclairage réalistes et sa puissante expression des détails.',
      faq2Question: 'Que peut-il faire?',
      faq2Answer: 'Il peut générer des images photoréalistes, des illustrations dans divers styles, des assets de jeux, des matériaux de design web, et dans v6.1, la capacité à générer des images avec du texte et maintenir la cohérence des personnages a été grandement améliorée.',
      faq3Question: 'Est-ce gratuit sur 微鲤AI?',
      faq3Answer: 'Le service officiel Midjourney est entièrement payant. Sur 微鲤AI, nous offrons des crédits d\'essai gratuits limités. Pour une utilisation intensive ou une génération commerciale, nous recommandons de souscrire à notre plan d\'adhésion.',
      faq4Question: 'Quelle est la qualité d\'image?',
      faq4Answer: 'Qualité extrêmement élevée. Midjourney génère par défaut une résolution de 1024x1024, et via son Upscaler intégré, peut produire des images HD de 2048x2048 ou plus avec des détails riches et sans flou.',
      faq5Question: 'En quoi diffère-t-il de Wan AI ou Seedream 4.5?',
      faq5Answer: 'Comparé à des modèles comme Wan AI ou Seedream 4.5, le plus grand avantage de Midjourney est son esthétique artistique ultime et sa qualité d\'éclairage. Il peut générer directement des images avec une composition cinématographique, des détails riches et un fort impact visuel sans prompts complexes.',
      faq6Question: 'Puis-je utiliser les images commercialement?',
      faq6Answer: 'Si vous êtes un abonné payant de 微鲤AI, vous avez généralement des droits d\'utilisation commerciale pour les images générées. Consultez les conditions d\'utilisation de 微鲤AI pour plus de détails.',
      ctaTitle: 'Essayez Midjourney Maintenant',
      ctaDescription: 'Utilisez gratuitement le modèle de génération d\'images IA de premier plan',
      ctaButton: 'Commencer à Créer',
      ctaDisclaimer: 'Pas de carte de crédit requise',
  },
  de: {
      pageTitle: 'Midjourney - Flexible, detaillierte und lebendige Bildgenerierung',
      shortDescription: 'Flexible, detaillierte und lebendige Bildgenerierung',
      generatorTitle: 'Midjourney Bildgenerator',
      generatorSubtitle: 'Midjourney ist das neueste Flaggschiff-KI-Bildmodell vom unabhängigen Forschungslabor Midjourney Inc. Bei Beibehaltung der branchenführenden Kunstfertigkeit und Beleuchtungsqualität wurden Bildkohärenz, anatomische Genauigkeit und Textrendering-Fähigkeiten erheblich verbessert.',
      coreFeaturesTitle: 'Midjourney Kernfunktionen',
      coreFeaturesSubtitle: 'Entdecken Sie die leistungsstarken Funktionen von Midjourney',
      feature1Title: 'Präzises Text-Rendering',
      feature1Desc: 'Deutlich verbesserte Fähigkeit, genauen Text in Bildern zu generieren. Durch Einschließen von Text in Anführungszeichen kann das Modell korrekt geschriebene Titel, Neonschilder oder Labels mit Schriftstilen generieren, die perfekt mit dem Bild verschmelzen.',
      feature2Title: 'Hyperrealistische Porträts und Anatomische Korrektur',
      feature2Desc: 'Tiefe Optimierung für häufige Hand- und Gliedmaßenfehler in der KI-Malerei. v6.1 kann anatomisch genaue Finger und Gliedmaßen generieren und hat den Realismus der Hauttextur erheblich verbessert.',
      feature3Title: 'Personalisierungs-Feinabstimmung',
      feature3Desc: 'Das Modell lernt und baut ein benutzerspezifisches ästhetisches Modell basierend auf den historischen Bewertungen und Präferenzen des Benutzers. Dies bedeutet, dass die von jeder Person generierten Bilder ihren einzigartigen persönlichen künstlerischen Stil tragen.',
      feature4Title: 'Intelligente Texturverbesserung und 2x-Hochskalierung',
      feature4Desc: 'Ausgestattet mit neuen Subtle- und Creative-Upscalern. Während die Bildauflösung verdoppelt wird, fügt das Modell intelligent kleine Details hinzu, die ursprünglich nicht existierten, und ermöglicht so 4K-Ausgabe.',
      howToUseTitle: 'So verwenden Sie Midjourney auf 微鲤AI',
      step1Title: 'Modell auswählen',
      step1Description: 'Wählen Sie Midjourney in den KI-Bildwerkzeugen',
      step2Title: 'Inhalt eingeben',
      step2Description: 'Geben Sie Prompts ein oder laden Sie Referenzbilder hoch',
      step3Title: 'Bild generieren',
      step3Description: 'Klicken Sie auf Generieren und laden Sie Ihr Bild herunter',
      youtubeTitle: 'YouTube-Videos über das Midjourney KI-Bildmodell',
      xPostsTitle: 'X-Beiträge über das Midjourney KI-Bildmodell',
      exploreModelsTitle: 'Entdecken Sie andere Bildmodelle auf 微鲤AI',
      model1Title: 'Nano Banana Pro',
      model2Title: 'Seedream 4.5',
      model3Title: 'Dreamina 4',
      model4Title: 'Wan 2.5',
      faqTitle: 'Häufig Gestellte Fragen',
      faq1Question: 'Was ist Midjourney?',
      faq1Answer: 'Midjourney wird als eines der umfassendsten KI-Bildgenerierungsmodelle anerkannt, bekannt für seine künstlerische Komposition, realistische Beleuchtungseffekte und leistungsstarke Detaildarstellung.',
      faq2Question: 'Was kann es?',
      faq2Answer: 'Es kann fotorealistische Bilder, Illustrationen in verschiedenen Stilen, Spiel-Assets, Webdesign-Materialien generieren, und in v6.1 wurde die Fähigkeit, Bilder mit Text zu generieren und Charakterkonsistenz zu wahren, erheblich verbessert.',
      faq3Question: 'Ist es auf 微鲤AI kostenlos?',
      faq3Answer: 'Der offizielle Midjourney-Dienst ist vollständig kostenpflichtig. Auf 微鲤AI bieten wir begrenzte kostenlose Testguthaben. Für häufige Nutzung oder kommerzielle Generierung empfehlen wir die Anmeldung für unseren Mitgliedschaftsplan.',
      faq4Question: 'Wie ist die Bildqualität?',
      faq4Answer: 'Extrem hohe Qualität. Midjourney generiert standardmäßig 1024x1024 Auflösung, und über seinen eingebauten Upscaler kann es 2048x2048 oder höhere HD-Bilder mit reichen Details und ohne Unschärfe ausgeben.',
      faq5Question: 'Wie unterscheidet es sich von Wan AI oder Seedream 4.5?',
      faq5Answer: 'Im Vergleich zu Modellen wie Wan AI oder Seedream 4.5 ist der größte Vorteil von Midjourney seine ultimative künstlerische Ästhetik und Beleuchtungsqualität. Es kann direkt Bilder mit filmischer Komposition, reichen Details und starker visueller Wirkung ohne komplexe Prompts generieren.',
      faq6Question: 'Kann ich die Bilder kommerziell nutzen?',
      faq6Answer: 'Wenn Sie ein zahlender Abonnent von 微鲤AI sind, haben Sie in der Regel kommerzielle Nutzungsrechte für generierte Bilder. Bitte beachten Sie die 微鲤AI-Nutzungsbedingungen für Details.',
      ctaTitle: 'Jetzt Midjourney ausprobieren',
      ctaDescription: 'Nutzen Sie kostenlos das erstklassige KI-Bildgenerierungsmodell',
      ctaButton: 'Erstellen beginnen',
      ctaDisclaimer: 'Keine Kreditkarte erforderlich',
  },
  ru: {
      pageTitle: 'Midjourney - Гибкая, детализированная и яркая генерация изображений',
      shortDescription: 'Гибкая, детализированная и яркая генерация изображений',
      generatorTitle: 'Генератор изображений Midjourney',
      generatorSubtitle: 'Midjourney — это новейшая флагманская модель изображений ИИ от независимой исследовательской лаборатории Midjourney Inc. Сохраняя лидирующую в отрасли художественность и качество освещения, она значительно улучшила согласованность изображений, анатомическую точность и возможности рендеринга текста.',
      coreFeaturesTitle: 'Основные функции Midjourney',
      coreFeaturesSubtitle: 'Изучите мощные возможности Midjourney',
      feature1Title: 'Точный рендеринг текста',
      feature1Desc: 'Значительно улучшена способность генерировать точный текст в изображениях. Обернув текст в двойные кавычки, модель может генерировать правильно написанные заголовки, неоновые вывески или метки со стилями шрифтов, которые идеально сочетаются с изображением.',
      feature2Title: 'Гиперреалистичные портреты и анатомическая коррекция',
      feature2Desc: 'Глубокая оптимизация для распространённых ошибок рук и конечностей в ИИ-рисовании. v6.1 может генерировать анатомически точные пальцы и конечности, и значительно улучшил реалистичность текстуры кожи.',
      feature3Title: 'Персонализированная тонкая настройка',
      feature3Desc: 'Модель учится и строит специфическую для пользователя эстетическую модель на основе исторических оценок и предпочтений пользователя. Это означает, что изображения, генерируемые каждым человеком, будут нести его уникальный личный художественный стиль.',
      feature4Title: 'Интеллектуальное улучшение текстуры и 2x масштабирование',
      feature4Desc: 'Оснащён новыми масштабаторами Subtle и Creative. Удваивая разрешение изображения, модель интеллектуально добавляет мелкие детали, которых изначально не существовало, делая возможным вывод 4K.',
      howToUseTitle: 'Как использовать Midjourney на 微鲤AI',
      step1Title: 'Выберите модель',
      step1Description: 'Выберите Midjourney в инструментах ИИ-изображений',
      step2Title: 'Введите контент',
      step2Description: 'Введите промпты или загрузите референсные изображения',
      step3Title: 'Сгенерируйте изображение',
      step3Description: 'Нажмите генерировать и скачайте изображение',
      youtubeTitle: 'Видео YouTube о модели изображений ИИ Midjourney',
      xPostsTitle: 'Посты X о модели изображений ИИ Midjourney',
      exploreModelsTitle: 'Изучите другие модели изображений на 微鲤AI',
      model1Title: 'Nano Banana Pro',
      model2Title: 'Seedream 4.5',
      model3Title: 'Dreamina 4',
      model4Title: 'Wan 2.5',
      faqTitle: 'Часто задаваемые вопросы',
      faq1Question: 'Что такое Midjourney?',
      faq1Answer: 'Midjourney признан одной из самых комплексных моделей генерации изображений ИИ, известной своей художественной композицией, реалистичными световыми эффектами и мощным выражением деталей.',
      faq2Question: 'Что она может делать?',
      faq2Answer: 'Она может генерировать фотореалистичные изображения, иллюстрации в различных стилях, игровые ассеты, материалы для веб-дизайна, и в v6.1 способность генерировать изображения с текстом и поддерживать согласованность персонажей была значительно улучшена.',
      faq3Question: 'Это бесплатно на 微鲤AI?',
      faq3Answer: 'Официальный сервис Midjourney полностью платный. На 微鲤AI мы предлагаем ограниченные бесплатные пробные кредиты. Для частого использования или коммерческой генерации рекомендуем подписаться на наш план членства.',
      faq4Question: 'Какое качество изображений?',
      faq4Answer: 'Чрезвычайно высокое качество. Midjourney по умолчанию генерирует разрешение 1024x1024, и через встроенный Upscaler может выводить HD-изображения 2048x2048 или выше с богатыми деталями и без размытия.',
      faq5Question: 'Чем отличается от Wan AI или Seedream 4.5?',
      faq5Answer: 'По сравнению с моделями типа Wan AI или Seedream 4.5, главное преимущество Midjourney — это абсолютная художественная эстетика и качество освещения. Она может напрямую генерировать изображения с кинематографической композицией, богатыми деталями и сильным визуальным воздействием без сложных промптов.',
      faq6Question: 'Могу ли я использовать изображения коммерчески?',
      faq6Answer: 'Если вы платный подписчик 微鲤AI, вы обычно имеете права на коммерческое использование сгенерированных изображений. Подробности см. в условиях обслуживания 微鲤AI.',
      ctaTitle: 'Попробуйте Midjourney сейчас',
      ctaDescription: 'Используйте бесплатно первоклассную модель генерации изображений ИИ',
      ctaButton: 'Начать создавать',
      ctaDisclaimer: 'Кредитная карта не требуется',
  },
  pt: {
      pageTitle: 'Midjourney - Geração de imagens flexível, detalhada e vibrante',
      shortDescription: 'Geração de imagens flexível, detalhada e vibrante',
      generatorTitle: 'Gerador de Imagens Midjourney',
      generatorSubtitle: 'Midjourney é o mais recente modelo de imagem IA principal do laboratório de pesquisa independente Midjourney Inc. Mantendo a artística e qualidade de iluminação líderes da indústria, melhorou significativamente a coerência de imagem, precisão anatômica e capacidades de renderização de texto.',
      coreFeaturesTitle: 'Recursos Principais do Midjourney',
      coreFeaturesSubtitle: 'Explore os recursos poderosos do Midjourney',
      feature1Title: 'Renderização de Texto Precisa',
      feature1Desc: 'Capacidade significativamente melhorada de gerar texto preciso em imagens. Envolvendo texto em aspas duplas, o modelo pode gerar títulos, letreiros de neon ou etiquetas corretamente escritos com estilos de fonte que se misturam perfeitamente com a imagem.',
      feature2Title: 'Retratos Hiperrealistas e Correção Anatômica',
      feature2Desc: 'Otimização profunda para erros comuns de mãos e membros na pintura IA. v6.1 pode gerar dedos e membros anatomicamente precisos, e melhorou grandemente o realismo da textura da pele.',
      feature3Title: 'Ajuste Fino de Personalização',
      feature3Desc: 'O modelo aprende e constrói um modelo estético específico do usuário baseado nas avaliações e preferências históricas do usuário. Isso significa que as imagens geradas por cada pessoa terão seu estilo artístico pessoal único.',
      feature4Title: 'Melhoria Inteligente de Textura e Ampliação 2x',
      feature4Desc: 'Equipado com novos upscalers Subtle e Creative. Enquanto dobra a resolução da imagem, o modelo adiciona inteligentemente pequenos detalhes que originalmente não existiam, tornando possível a saída 4K.',
      howToUseTitle: 'Como Usar Midjourney no 微鲤AI',
      step1Title: 'Selecionar Modelo',
      step1Description: 'Escolha Midjourney nas ferramentas de imagem IA',
      step2Title: 'Inserir Conteúdo',
      step2Description: 'Digite prompts ou carregue imagens de referência',
      step3Title: 'Gerar Imagem',
      step3Description: 'Clique em gerar e baixe sua imagem',
      youtubeTitle: 'Vídeos do YouTube sobre o Modelo de Imagem IA Midjourney',
      xPostsTitle: 'Posts do X sobre o Modelo de Imagem IA Midjourney',
      exploreModelsTitle: 'Explore Outros Modelos de Imagem no 微鲤AI',
      model1Title: 'Nano Banana Pro',
      model2Title: 'Seedream 4.5',
      model3Title: 'Dreamina 4',
      model4Title: 'Wan 2.5',
      faqTitle: 'Perguntas Frequentes',
      faq1Question: 'O que é Midjourney?',
      faq1Answer: 'Midjourney é reconhecido como um dos modelos de geração de imagens IA mais abrangentes, famoso por sua composição artística, efeitos de iluminação realistas e poderosa expressão de detalhes.',
      faq2Question: 'O que ele pode fazer?',
      faq2Answer: 'Pode gerar imagens fotorrealistas, ilustrações em vários estilos, assets de jogos, materiais de design web, e em v6.1, a capacidade de gerar imagens com texto e manter consistência de personagens foi grandemente melhorada.',
      faq3Question: 'É grátis no 微鲤AI?',
      faq3Answer: 'O serviço oficial do Midjourney é totalmente pago. No 微鲤AI, oferecemos créditos de teste gratuitos limitados. Para uso de alta frequência ou geração comercial, recomendamos assinar nosso plano de associação.',
      faq4Question: 'Qual é a qualidade da imagem?',
      faq4Answer: 'Qualidade extremamente alta. Midjourney gera resolução 1024x1024 por padrão, e através de seu Upscaler embutido, pode produzir imagens HD de 2048x2048 ou superiores com detalhes ricos e sem desfoque.',
      faq5Question: 'Como é diferente do Wan AI ou Seedream 4.5?',
      faq5Answer: 'Comparado a modelos como Wan AI ou Seedream 4.5, a maior vantagem do Midjourney é sua estética artística definitiva e qualidade de iluminação. Pode gerar diretamente imagens com composição cinematográfica, detalhes ricos e forte impacto visual sem prompts complexos.',
      faq6Question: 'Posso usar as imagens comercialmente?',
      faq6Answer: 'Se você é um assinante pago do 微鲤AI, normalmente tem direitos de uso comercial para imagens geradas. Consulte os termos de serviço do 微鲤AI para detalhes.',
      ctaTitle: 'Experimente Midjourney Agora',
      ctaDescription: 'Use gratuitamente o modelo de geração de imagens IA de primeira linha',
      ctaButton: 'Começar a Criar',
      ctaDisclaimer: 'Sem necessidade de cartão de crédito',
  },
  it: {
      pageTitle: 'Midjourney - Generazione di immagini flessibile, dettagliata e vivace',
      shortDescription: 'Generazione di immagini flessibile, dettagliata e vivace',
      generatorTitle: 'Generatore di Immagini Midjourney',
      generatorSubtitle: 'Midjourney è l\'ultimo modello di immagini IA di punta del laboratorio di ricerca indipendente Midjourney Inc. Mantenendo l\'artistica e la qualità di illuminazione leader del settore, ha migliorato significativamente la coerenza dell\'immagine, la precisione anatomica e le capacità di rendering del testo.',
      coreFeaturesTitle: 'Funzionalità Principali di Midjourney',
      coreFeaturesSubtitle: 'Esplora le potenti funzionalità di Midjourney',
      feature1Title: 'Rendering del Testo Preciso',
      feature1Desc: 'Capacità significativamente migliorata di generare testo preciso nelle immagini. Racchiudendo il testo tra virgolette doppie, il modello può generare titoli, insegne al neon o etichette scritti correttamente con stili di carattere che si fondono perfettamente con l\'immagine.',
      feature2Title: 'Ritratti Iperrealistici e Correzione Anatomica',
      feature2Desc: 'Ottimizzazione profonda per gli errori comuni di mani e arti nella pittura IA. v6.1 può generare dita e arti anatomicamente precisi, e ha migliorato notevolmente il realismo della texture della pelle.',
      feature3Title: 'Messa a Punto della Personalizzazione',
      feature3Desc: 'Il modello impara e costruisce un modello estetico specifico dell\'utente basato sulle valutazioni storiche e preferenze dell\'utente. Ciò significa che le immagini generate da ogni persona porteranno il loro stile artistico personale unico.',
      feature4Title: 'Miglioramento Intelligente della Texture e Ingrandimento 2x',
      feature4Desc: 'Dotato di nuovi upscaler Subtle e Creative. Mentre raddoppia la risoluzione dell\'immagine, il modello aggiunge intelligentemente piccoli dettagli che originariamente non esistevano, rendendo possibile l\'output 4K.',
      howToUseTitle: 'Come Usare Midjourney su 微鲤AI',
      step1Title: 'Seleziona Modello',
      step1Description: 'Scegli Midjourney negli strumenti immagine IA',
      step2Title: 'Inserisci Contenuto',
      step2Description: 'Inserisci prompt o carica immagini di riferimento',
      step3Title: 'Genera Immagine',
      step3Description: 'Clicca genera e scarica la tua immagine',
      youtubeTitle: 'Video YouTube sul Modello Immagine IA Midjourney',
      xPostsTitle: 'Post X sul Modello Immagine IA Midjourney',
      exploreModelsTitle: 'Esplora Altri Modelli di Immagini su 微鲤AI',
      model1Title: 'Nano Banana Pro',
      model2Title: 'Seedream 4.5',
      model3Title: 'Dreamina 4',
      model4Title: 'Wan 2.5',
      faqTitle: 'Domande Frequenti',
      faq1Question: 'Cos\'è Midjourney?',
      faq1Answer: 'Midjourney è riconosciuto come uno dei modelli di generazione di immagini IA più completi, famoso per la sua composizione artistica, effetti di illuminazione realistici e potente espressione dei dettagli.',
      faq2Question: 'Cosa può fare?',
      faq2Answer: 'Può generare immagini fotorealistiche, illustrazioni in vari stili, asset di giochi, materiali di web design, e in v6.1, la capacità di generare immagini con testo e mantenere la coerenza dei personaggi è stata notevolmente migliorata.',
      faq3Question: 'È gratuito su 微鲤AI?',
      faq3Answer: 'Il servizio ufficiale di Midjourney è completamente a pagamento. Su 微鲤AI, offriamo crediti di prova gratuiti limitati. Per uso ad alta frequenza o generazione commerciale, raccomandiamo di abbonarsi al nostro piano di membership.',
      faq4Question: 'Qual è la qualità dell\'immagine?',
      faq4Answer: 'Qualità estremamente alta. Midjourney genera risoluzione 1024x1024 di default, e attraverso il suo Upscaler integrato, può produrre immagini HD 2048x2048 o superiori con dettagli ricchi e senza sfocatura.',
      faq5Question: 'Come si differenzia da Wan AI o Seedream 4.5?',
      faq5Answer: 'Rispetto a modelli come Wan AI o Seedream 4.5, il più grande vantaggio di Midjourney è la sua estetica artistica definitiva e qualità di illuminazione. Può generare direttamente immagini con composizione cinematografica, dettagli ricchi e forte impatto visivo senza prompt complessi.',
      faq6Question: 'Posso usare le immagini commercialmente?',
      faq6Answer: 'Se sei un abbonato a pagamento di 微鲤AI, generalmente hai diritti di uso commerciale per le immagini generate. Consulta i termini di servizio di 微鲤AI per i dettagli.',
      ctaTitle: 'Prova Midjourney Ora',
      ctaDescription: 'Usa gratuitamente il modello di generazione immagini IA di prima classe',
      ctaButton: 'Inizia a Creare',
      ctaDisclaimer: 'Nessuna carta di credito richiesta',
  },
  ar: {
      pageTitle: 'Midjourney - توليد صور مرن ومفصل ونابض بالحياة',
      shortDescription: 'توليد صور مرن ومفصل ونابض بالحياة',
      generatorTitle: 'مولد الصور Midjourney',
      generatorSubtitle: 'Midjourney هو أحدث نموذج صور بالذكاء الاصطناعي الرائد من مختبر الأبحاث المستقل Midjourney Inc. مع الحفاظ على الفنية وجودة الإضاءة الرائدة في الصناعة، فقد حسّن بشكل كبير تماسك الصورة والدقة التشريحية وقدرات عرض النص.',
      coreFeaturesTitle: 'الميزات الأساسية لـ Midjourney',
      coreFeaturesSubtitle: 'استكشف الميزات القوية لـ Midjourney',
      feature1Title: 'عرض نص دقيق',
      feature1Desc: 'تحسين كبير في القدرة على توليد نص دقيق في الصور. من خلال وضع النص بين علامات اقتباس مزدوجة، يمكن للنموذج توليد عناوين ولافتات نيون أو ملصقات مكتوبة بشكل صحيح مع أنماط خطوط تمتزج بشكل مثالي مع الصورة.',
      feature2Title: 'صور شخصية فائقة الواقعية وتصحيح تشريحي',
      feature2Desc: 'تحسين عميق لأخطاء اليد والأطراف الشائعة في الرسم بالذكاء الاصطناعي. يمكن لـ v6.1 توليد أصابع وأطراف دقيقة تشريحياً، وحسّن بشكل كبير واقعية نسيج الجلد.',
      feature3Title: 'ضبط دقيق للتخصيص',
      feature3Desc: 'يتعلم النموذج ويبني نموذجاً جمالياً خاصاً بالمستخدم بناءً على تقييمات وتفضيلات المستخدم التاريخية. هذا يعني أن الصور التي يولدها كل شخص ستحمل أسلوبه الفني الشخصي الفريد.',
      feature4Title: 'تحسين ذكي للنسيج وتكبير 2x',
      feature4Desc: 'مجهز بمكبرات Subtle و Creative الجديدة. أثناء مضاعفة دقة الصورة، يضيف النموذج بذكاء تفاصيل صغيرة لم تكن موجودة في الأصل، مما يجعل إخراج 4K ممكناً.',
      howToUseTitle: 'كيفية استخدام Midjourney على 微鲤AI',
      step1Title: 'اختر النموذج',
      step1Description: 'اختر Midjourney في أدوات الصور بالذكاء الاصطناعي',
      step2Title: 'أدخل المحتوى',
      step2Description: 'أدخل المطالبات أو حمّل الصور المرجعية',
      step3Title: 'ولّد الصورة',
      step3Description: 'انقر على توليد وحمّل صورتك',
      youtubeTitle: 'فيديوهات يوتيوب حول نموذج الصور بالذكاء الاصطناعي Midjourney',
      xPostsTitle: 'منشورات X حول نموذج الصور بالذكاء الاصطناعي Midjourney',
      exploreModelsTitle: 'استكشف نماذج الصور الأخرى على 微鲤AI',
      model1Title: 'Nano Banana Pro',
      model2Title: 'Seedream 4.5',
      model3Title: 'Dreamina 4',
      model4Title: 'Wan 2.5',
      faqTitle: 'الأسئلة الشائعة',
      faq1Question: 'ما هو Midjourney؟',
      faq1Answer: 'Midjourney معترف به كأحد أكثر نماذج توليد الصور بالذكاء الاصطناعي شمولاً، مشهور بتكوينه الفني وتأثيرات الإضاءة الواقعية والتعبير القوي عن التفاصيل.',
      faq2Question: 'ماذا يمكنه أن يفعل؟',
      faq2Answer: 'يمكنه توليد صور واقعية ورسوم توضيحية بأساليب مختلفة وأصول ألعاب ومواد تصميم ويب، وفي v6.1، تحسنت بشكل كبير القدرة على توليد صور بنص والحفاظ على اتساق الشخصيات.',
      faq3Question: 'هل هو مجاني على 微鲤AI؟',
      faq3Answer: 'خدمة Midjourney الرسمية مدفوعة بالكامل. على 微鲤AI، نقدم أرصدة تجريبية مجانية محدودة. للاستخدام عالي التردد أو التوليد التجاري، نوصي بالاشتراك في خطة عضويتنا.',
      faq4Question: 'ما هي جودة الصورة؟',
      faq4Answer: 'جودة عالية للغاية. يولد Midjourney دقة 1024x1024 افتراضياً، ومن خلال Upscaler المدمج، يمكنه إخراج صور HD بدقة 2048x2048 أو أعلى بتفاصيل غنية وبدون ضبابية.',
      faq5Question: 'كيف يختلف عن Wan AI أو Seedream 4.5؟',
      faq5Answer: 'مقارنة بنماذج مثل Wan AI أو Seedream 4.5، أكبر ميزة لـ Midjourney هي جمالياته الفنية المطلقة وجودة الإضاءة. يمكنه توليد صور مباشرة بتكوين سينمائي وتفاصيل غنية وتأثير بصري قوي بدون مطالبات معقدة.',
      faq6Question: 'هل يمكنني استخدام الصور تجارياً؟',
      faq6Answer: 'إذا كنت مشتركاً مدفوعاً في 微鲤AI، فعادة ما تملك حقوق الاستخدام التجاري للصور المولدة. يرجى الرجوع إلى شروط خدمة 微鲤AI للتفاصيل.',
      ctaTitle: 'جرب Midjourney الآن',
      ctaDescription: 'استخدم مجاناً نموذج توليد الصور بالذكاء الاصطناعي من الطراز الأول',
      ctaButton: 'ابدأ الإنشاء',
      ctaDisclaimer: 'لا حاجة لبطاقة ائتمان',
  },
  tw: {
      pageTitle: 'Midjourney - 靈活、細膩且充滿活力的圖像生成',
      shortDescription: '靈活、細膩且充滿活力的圖像生成',
      generatorTitle: 'Midjourney 圖像生成器',
      generatorSubtitle: 'Midjourney 是獨立研究實驗室 Midjourney Inc. 推出的最新一代旗艦級 AI 圖像模型。它在保持業界領先的藝術性和光影質感的同時，大幅提升了畫面的連貫性、肢體解剖學的準確性以及文字渲染能力。',
      coreFeaturesTitle: 'Midjourney 核心功能',
      coreFeaturesSubtitle: '探索 Midjourney 的強大功能',
      feature1Title: '精準文字渲染',
      feature1Desc: '顯著提升了在圖像中生成準確文本的能力。通過使用雙引號將文字包裹，模型能夠生成拼寫正確、字體風格與畫面完美融合的標題、霓虹燈牌或標籤。',
      feature2Title: '超寫實人像與解剖學修正',
      feature2Desc: '針對 AI 繪畫中常見的手部和肢體錯誤進行了深度優化。v6.1 能生成解剖結構準確的手指、四肢，並極大地增強了皮膚紋理的真實感。',
      feature3Title: '個性化模型微調',
      feature3Desc: '模型會根據用戶的歷史評分和偏好，學習並建立用戶專屬的審美模型。這意味著每個人生成的圖片都將帶有獨特的個人藝術風格。',
      feature4Title: '智能紋理增強與 2x 放大',
      feature4Desc: '配備了全新的 Subtle 和 Creative 放大器。在將圖像解析度放大 2 倍的同時，模型會智能補充原本不存在的微小細節，使 4K 輸出成為可能。',
      howToUseTitle: '如何在 微鲤AI 上使用 Midjourney',
      step1Title: '選擇模型',
      step1Description: '在 AI 圖像工具中選擇 Midjourney',
      step2Title: '輸入內容',
      step2Description: '輸入提示詞或上傳參考圖像',
      step3Title: '生成圖像',
      step3Description: '點擊生成並下載您的圖像',
      youtubeTitle: '關於 Midjourney AI 圖像模型的 YouTube 影片',
      xPostsTitle: '關於 Midjourney AI 圖像模型的 X 貼文',
      exploreModelsTitle: '探索 微鲤AI 上的其他圖像模型',
      model1Title: 'Nano Banana Pro',
      model2Title: 'Seedream 4.5',
      model3Title: 'Dreamina 4',
      model4Title: 'Wan 2.5',
      faqTitle: '常見問題',
      faq1Question: 'Midjourney 是什麼？',
      faq1Answer: 'Midjourney 是目前公認綜合效果最強的 AI 圖像生成模型之一，以其富有藝術感的構圖、逼真的光影效果和強大的細節表現力而著稱。',
      faq2Question: '它主要能做什麼？',
      faq2Answer: '它能生成照片級寫實圖像、各種風格的插畫、遊戲資產、網頁設計素材，並且在 v6.1 版本中，生成帶文字的圖片和保持人物一致性的能力得到了巨大提升。',
      faq3Question: '在 微鲤AI 上使用是免費的嗎？',
      faq3Answer: 'Midjourney 官方服務是完全付費的。在 微鲤AI 上，我們提供有限的免費試用額度，如需高頻使用或商用生成，建議訂閱我們的會員計劃。',
      faq4Question: '生成圖片的品質如何？',
      faq4Answer: '品質極高。Midjourney 預設生成 1024x1024 解析度，通過其內建的 Upscaler，可以輸出 2048x2048 甚至更高的高清圖，且細節豐富，無模糊感。',
      faq5Question: '它和 Wan AI、Seedream 4.5 有什麼區別？',
      faq5Answer: '相比其他模型，Midjourney 最大的優勢在於極致的藝術審美與光影質感。它能在無需複雜提示詞的情況下，直接生成具有電影級構圖、豐富細節和強烈視覺衝擊力的圖像。',
      faq6Question: '我可以將生成的圖片用於商業用途嗎？',
      faq6Answer: '如果您是 微鲤AI 的付費訂閱用戶，您通常擁有生成圖片的商業使用權。具體請參考 微鲤AI 的服務條款。',
      ctaTitle: '立即體驗 Midjourney',
      ctaDescription: '免費使用頂級 AI 圖像生成模型',
      ctaButton: '開始創作',
      ctaDisclaimer: '無需信用卡',
  },
  pl: {
      pageTitle: 'Midjourney - Elastyczne, szczegółowe i żywe generowanie obrazów',
      shortDescription: 'Elastyczne, szczegółowe i żywe generowanie obrazów',
      generatorTitle: 'Generator obrazów Midjourney',
      generatorSubtitle: 'Midjourney to najnowszy flagowy model obrazów AI od niezależnego laboratorium badawczego Midjourney Inc. Zachowując wiodącą w branży artystyczność i jakość oświetlenia, znacząco poprawił spójność obrazu, dokładność anatomiczną i możliwości renderowania tekstu.',
      coreFeaturesTitle: 'Główne funkcje Midjourney',
      coreFeaturesSubtitle: 'Odkryj potężne możliwości Midjourney',
      feature1Title: 'Precyzyjne renderowanie tekstu',
      feature1Desc: 'Znacząco poprawiona zdolność generowania dokładnego tekstu w obrazach. Otaczając tekst cudzysłowami, model może generować poprawnie napisane tytuły, neony lub etykiety ze stylami czcionek idealnie pasującymi do obrazu.',
      feature2Title: 'Hiperrealistyczne portrety i korekta anatomiczna',
      feature2Desc: 'Głęboka optymalizacja dla typowych błędów rąk i kończyn w malarstwie AI. v6.1 może generować anatomicznie dokładne palce i kończyny oraz znacznie poprawił realizm tekstury skóry.',
      feature3Title: 'Dostrajanie personalizacji',
      feature3Desc: 'Model uczy się i buduje specyficzny dla użytkownika model estetyczny na podstawie historycznych ocen i preferencji użytkownika. Oznacza to, że obrazy generowane przez każdą osobę będą miały unikalny osobisty styl artystyczny.',
      feature4Title: 'Inteligentne ulepszanie tekstur i skalowanie 2x',
      feature4Desc: 'Wyposażony w nowe skalery Subtle i Creative. Podwajając rozdzielczość obrazu, model inteligentnie dodaje drobne szczegóły, które pierwotnie nie istniały, umożliwiając wyjście 4K.',
      howToUseTitle: 'Jak używać Midjourney na 微鲤AI',
      step1Title: 'Wybierz model',
      step1Description: 'Wybierz Midjourney w narzędziach obrazów AI',
      step2Title: 'Wprowadź treść',
      step2Description: 'Wprowadź prompt lub prześlij obrazy referencyjne',
      step3Title: 'Wygeneruj obraz',
      step3Description: 'Kliknij generuj i pobierz swój obraz',
      youtubeTitle: 'Filmy YouTube o modelu obrazów AI Midjourney',
      xPostsTitle: 'Posty X o modelu obrazów AI Midjourney',
      exploreModelsTitle: 'Odkryj inne modele obrazów na 微鲤AI',
      model1Title: 'Nano Banana Pro',
      model2Title: 'Seedream 4.5',
      model3Title: 'Dreamina 4',
      model4Title: 'Wan 2.5',
      faqTitle: 'Najczęściej zadawane pytania',
      faq1Question: 'Czym jest Midjourney?',
      faq1Answer: 'Midjourney jest uznawany za jeden z najbardziej kompleksowych modeli generowania obrazów AI, słynący z artystycznej kompozycji, realistycznych efektów oświetlenia i potężnej ekspresji szczegółów.',
      faq2Question: 'Co może zrobić?',
      faq2Answer: 'Może generować fotorealistyczne obrazy, ilustracje w różnych stylach, zasoby gier, materiały do projektowania stron, a w v6.1 znacznie poprawiono zdolność generowania obrazów z tekstem i utrzymywania spójności postaci.',
      faq3Question: 'Czy jest darmowy na 微鲤AI?',
      faq3Answer: 'Oficjalna usługa Midjourney jest w pełni płatna. Na 微鲤AI oferujemy ograniczone darmowe kredyty próbne. Do częstego użytku lub generowania komercyjnego zalecamy subskrypcję naszego planu członkowskiego.',
      faq4Question: 'Jaka jest jakość obrazu?',
      faq4Answer: 'Niezwykle wysoka jakość. Midjourney domyślnie generuje rozdzielczość 1024x1024, a przez wbudowany Upscaler może wyprowadzać obrazy HD 2048x2048 lub wyższe z bogatymi szczegółami i bez rozmycia.',
      faq5Question: 'Czym różni się od Wan AI lub Seedream 4.5?',
      faq5Answer: 'W porównaniu z modelami takimi jak Wan AI czy Seedream 4.5, największą zaletą Midjourney jest ostateczna estetyka artystyczna i jakość oświetlenia. Może bezpośrednio generować obrazy z kinową kompozycją, bogatymi szczegółami i silnym wizualnym wpływem bez skomplikowanych promptów.',
      faq6Question: 'Czy mogę używać obrazów komercyjnie?',
      faq6Answer: 'Jeśli jesteś płatnym subskrybentem 微鲤AI, zazwyczaj masz prawa do komercyjnego użycia wygenerowanych obrazów. Szczegóły znajdziesz w warunkach korzystania z 微鲤AI.',
      ctaTitle: 'Wypróbuj Midjourney teraz',
      ctaDescription: 'Używaj za darmo najwyższej klasy modelu generowania obrazów AI',
      ctaButton: 'Zacznij tworzyć',
      ctaDisclaimer: 'Nie wymaga karty kredytowej',
      },
    th: { // Thai (copied from English)
      // SEO Meta
      pageTitle: 'Midjourney - Flexible, detailed and vibrant image generation',
      pageDescription: 'Midjourney is a flagship AI image model from an independent research lab, renowned for its artistic aesthetics and lighting quality. Try it free on 微鲤AI.',
      shortDescription: 'Flexible, detailed and vibrant image generation',
      pageKeywords: 'Midjourney, AI image generation, artistic creation, lighting quality, text rendering, hyperrealistic portraits, 微鲤AI',
      ogTitle: 'Midjourney AI Image Generator | 微鲤AI',
      ogDescription: 'Midjourney flagship AI image model with ultimate artistic aesthetics and lighting quality',
      twitterTitle: 'Midjourney - Flexible, detailed and vibrant image generation',
      twitterDescription: 'Experience Midjourney powerful image generation with ultimate artistic sense and detail expression',

      // Generator Section
      generatorTitle: 'Midjourney Image Generator',
      generatorSubtitle: 'Midjourney is the latest generation flagship AI image model from independent research lab Midjourney Inc. While maintaining industry-leading artistry and lighting quality, it has significantly improved image coherence, anatomical accuracy of limbs, and text rendering capabilities. The model is renowned for its nuanced understanding of natural language, realistic skin texture rendering, and unique personalization fine-tuning features, making it the preferred tool for digital artists, photographers, and high-end design professionals worldwide. Experience the ultimate visual impact of Midjourney on 微鲤AI!',

      // Core Features
      coreFeaturesTitle: 'Midjourney Core Features',
      coreFeaturesSubtitle: 'Explore the powerful features of Midjourney and start your professional AI image creation journey',

      feature1Title: 'Precise Text Rendering',
      feature1Desc: 'Significantly improved ability to generate accurate text in images. By wrapping text in double quotes (" "), the model can generate correctly spelled titles, neon signs, or labels with font styles that perfectly blend with the image, solving the pain point of AI struggling with specific characters.',
      feature1Alt: 'Midjourney precise text rendering example',

      feature2Title: 'Hyperrealistic Portraits & Anatomical Correction',
      feature2Desc: 'Deep optimization for common hand and limb errors in AI painting. v6.1 can generate anatomically accurate fingers and limbs, and greatly enhanced skin texture realism, including pores, wrinkles, and subsurface scattering effects of light on skin, reaching commercial photography level.',
      feature2Alt: 'Midjourney hyperrealistic portrait example',

      feature3Title: 'Personalization Fine-tuning',
      feature3Desc: 'The model learns and builds a user-specific aesthetic model based on user history ratings and preferences. This means images generated by each person will carry their unique personal artistic style, rather than just generic "AI flavor".',
      feature3Alt: 'Midjourney personalization example',

      feature4Title: 'Intelligent Texture Enhancement & 2x Upscaling',
      feature4Desc: 'Equipped with new Subtle and Creative upscalers. While doubling the image resolution, the model intelligently adds small details that did not originally exist (such as fabric fibers, distant leaves), making 4K output possible without over-smoothing or artifacts.',
      feature4Alt: 'Midjourney intelligent upscaling example',

      // How to Use
      howToUseTitle: 'How to Use Midjourney on 微鲤AI',
      howToUseSubtitle: 'Get started in just three steps',

      step1Title: 'Select Model',
      step1Description: 'Choose Midjourney in the AI Image tools',

      step2Title: 'Enter Content',
      step2Description: 'Enter prompts or upload reference images',

      step3Title: 'Generate Image',
      step3Description: 'Click generate and download your image',

      // YouTube Section
      youtubeTitle: 'YouTube Videos About Midjourney AI Image Model',

      // X Posts Section
      xPostsTitle: 'X Posts About Midjourney AI Image Model',

      // Explore Models
      exploreModelsTitle: 'Explore Other Image Models on 微鲤AI',
      model1Title: 'Nano Banana Pro',
      model2Title: 'Seedream 4.5',
      model3Title: 'Dreamina 4',
      model4Title: 'Wan 2.5',

      // FAQ
      faqTitle: 'Frequently Asked Questions',

      faq1Question: 'What is Midjourney?',
      faq1Answer: 'Midjourney is recognized as one of the most comprehensive AI image generation models, renowned for its artistic composition, realistic lighting effects, and powerful detail expression.',

      faq2Question: 'What can it do?',
      faq2Answer: 'It can generate photo-realistic images, illustrations in various styles, game assets, web design materials, and in v6.1, the ability to generate images with text and maintain character consistency has been greatly improved.',

      faq3Question: 'Is it free to use on 微鲤AI?',
      faq3Answer: 'Midjourney official service is fully paid. On 微鲤AI, we offer limited free trial credits. For high-frequency use or commercial generation, we recommend subscribing to our membership plan for more stable access.',

      faq4Question: 'What is the image quality?',
      faq4Answer: 'Extremely high quality. Midjourney generates 1024x1024 resolution by default, and through its built-in Upscaler, can output 2048x2048 or higher HD images with rich details and no blur.',

      faq5Question: 'How is it different from Wan AI or Seedream 4.5?',
      faq5Answer: 'Compared to models like Wan AI or Seedream 4.5, Midjourney greatest advantage is its ultimate artistic aesthetics and lighting quality. While Seedream is more precise in multi-image consistency control and Nano Banana Pro is faster, Midjourney can directly generate images with cinematic composition, rich details, and strong visual impact without complex prompts, making it the first choice for high-quality artistic creation.',

      faq6Question: 'Can I use generated images commercially?',
      faq6Answer: 'If you are a paid subscriber of 微鲤AI, you typically have commercial usage rights for generated images. Please refer to 微鲤AI terms of service for details.',

      // CTA Section
      ctaTitle: 'Try Midjourney Now',
      ctaDescription: 'Use the top-tier AI image generation model for free',
      ctaButton: 'Start Creating',
      ctaDisclaimer: 'No credit card required',
      },
    da: { // Danish (copied from English)
      // SEO Meta
      pageTitle: 'Midjourney - Flexible, detailed and vibrant image generation',
      pageDescription: 'Midjourney is a flagship AI image model from an independent research lab, renowned for its artistic aesthetics and lighting quality. Try it free on 微鲤AI.',
      shortDescription: 'Flexible, detailed and vibrant image generation',
      pageKeywords: 'Midjourney, AI image generation, artistic creation, lighting quality, text rendering, hyperrealistic portraits, 微鲤AI',
      ogTitle: 'Midjourney AI Image Generator | 微鲤AI',
      ogDescription: 'Midjourney flagship AI image model with ultimate artistic aesthetics and lighting quality',
      twitterTitle: 'Midjourney - Flexible, detailed and vibrant image generation',
      twitterDescription: 'Experience Midjourney powerful image generation with ultimate artistic sense and detail expression',

      // Generator Section
      generatorTitle: 'Midjourney Image Generator',
      generatorSubtitle: 'Midjourney is the latest generation flagship AI image model from independent research lab Midjourney Inc. While maintaining industry-leading artistry and lighting quality, it has significantly improved image coherence, anatomical accuracy of limbs, and text rendering capabilities. The model is renowned for its nuanced understanding of natural language, realistic skin texture rendering, and unique personalization fine-tuning features, making it the preferred tool for digital artists, photographers, and high-end design professionals worldwide. Experience the ultimate visual impact of Midjourney on 微鲤AI!',

      // Core Features
      coreFeaturesTitle: 'Midjourney Core Features',
      coreFeaturesSubtitle: 'Explore the powerful features of Midjourney and start your professional AI image creation journey',

      feature1Title: 'Precise Text Rendering',
      feature1Desc: 'Significantly improved ability to generate accurate text in images. By wrapping text in double quotes (" "), the model can generate correctly spelled titles, neon signs, or labels with font styles that perfectly blend with the image, solving the pain point of AI struggling with specific characters.',
      feature1Alt: 'Midjourney precise text rendering example',

      feature2Title: 'Hyperrealistic Portraits & Anatomical Correction',
      feature2Desc: 'Deep optimization for common hand and limb errors in AI painting. v6.1 can generate anatomically accurate fingers and limbs, and greatly enhanced skin texture realism, including pores, wrinkles, and subsurface scattering effects of light on skin, reaching commercial photography level.',
      feature2Alt: 'Midjourney hyperrealistic portrait example',

      feature3Title: 'Personalization Fine-tuning',
      feature3Desc: 'The model learns and builds a user-specific aesthetic model based on user history ratings and preferences. This means images generated by each person will carry their unique personal artistic style, rather than just generic "AI flavor".',
      feature3Alt: 'Midjourney personalization example',

      feature4Title: 'Intelligent Texture Enhancement & 2x Upscaling',
      feature4Desc: 'Equipped with new Subtle and Creative upscalers. While doubling the image resolution, the model intelligently adds small details that did not originally exist (such as fabric fibers, distant leaves), making 4K output possible without over-smoothing or artifacts.',
      feature4Alt: 'Midjourney intelligent upscaling example',

      // How to Use
      howToUseTitle: 'How to Use Midjourney on 微鲤AI',
      howToUseSubtitle: 'Get started in just three steps',

      step1Title: 'Select Model',
      step1Description: 'Choose Midjourney in the AI Image tools',

      step2Title: 'Enter Content',
      step2Description: 'Enter prompts or upload reference images',

      step3Title: 'Generate Image',
      step3Description: 'Click generate and download your image',

      // YouTube Section
      youtubeTitle: 'YouTube Videos About Midjourney AI Image Model',

      // X Posts Section
      xPostsTitle: 'X Posts About Midjourney AI Image Model',

      // Explore Models
      exploreModelsTitle: 'Explore Other Image Models on 微鲤AI',
      model1Title: 'Nano Banana Pro',
      model2Title: 'Seedream 4.5',
      model3Title: 'Dreamina 4',
      model4Title: 'Wan 2.5',

      // FAQ
      faqTitle: 'Frequently Asked Questions',

      faq1Question: 'What is Midjourney?',
      faq1Answer: 'Midjourney is recognized as one of the most comprehensive AI image generation models, renowned for its artistic composition, realistic lighting effects, and powerful detail expression.',

      faq2Question: 'What can it do?',
      faq2Answer: 'It can generate photo-realistic images, illustrations in various styles, game assets, web design materials, and in v6.1, the ability to generate images with text and maintain character consistency has been greatly improved.',

      faq3Question: 'Is it free to use on 微鲤AI?',
      faq3Answer: 'Midjourney official service is fully paid. On 微鲤AI, we offer limited free trial credits. For high-frequency use or commercial generation, we recommend subscribing to our membership plan for more stable access.',

      faq4Question: 'What is the image quality?',
      faq4Answer: 'Extremely high quality. Midjourney generates 1024x1024 resolution by default, and through its built-in Upscaler, can output 2048x2048 or higher HD images with rich details and no blur.',

      faq5Question: 'How is it different from Wan AI or Seedream 4.5?',
      faq5Answer: 'Compared to models like Wan AI or Seedream 4.5, Midjourney greatest advantage is its ultimate artistic aesthetics and lighting quality. While Seedream is more precise in multi-image consistency control and Nano Banana Pro is faster, Midjourney can directly generate images with cinematic composition, rich details, and strong visual impact without complex prompts, making it the first choice for high-quality artistic creation.',

      faq6Question: 'Can I use generated images commercially?',
      faq6Answer: 'If you are a paid subscriber of 微鲤AI, you typically have commercial usage rights for generated images. Please refer to 微鲤AI terms of service for details.',

      // CTA Section
      ctaTitle: 'Try Midjourney Now',
      ctaDescription: 'Use the top-tier AI image generation model for free',
      ctaButton: 'Start Creating',
      ctaDisclaimer: 'No credit card required',
      },
    no: { // Norwegian (copied from English)
      // SEO Meta
      pageTitle: 'Midjourney - Flexible, detailed and vibrant image generation',
      pageDescription: 'Midjourney is a flagship AI image model from an independent research lab, renowned for its artistic aesthetics and lighting quality. Try it free on 微鲤AI.',
      shortDescription: 'Flexible, detailed and vibrant image generation',
      pageKeywords: 'Midjourney, AI image generation, artistic creation, lighting quality, text rendering, hyperrealistic portraits, 微鲤AI',
      ogTitle: 'Midjourney AI Image Generator | 微鲤AI',
      ogDescription: 'Midjourney flagship AI image model with ultimate artistic aesthetics and lighting quality',
      twitterTitle: 'Midjourney - Flexible, detailed and vibrant image generation',
      twitterDescription: 'Experience Midjourney powerful image generation with ultimate artistic sense and detail expression',

      // Generator Section
      generatorTitle: 'Midjourney Image Generator',
      generatorSubtitle: 'Midjourney is the latest generation flagship AI image model from independent research lab Midjourney Inc. While maintaining industry-leading artistry and lighting quality, it has significantly improved image coherence, anatomical accuracy of limbs, and text rendering capabilities. The model is renowned for its nuanced understanding of natural language, realistic skin texture rendering, and unique personalization fine-tuning features, making it the preferred tool for digital artists, photographers, and high-end design professionals worldwide. Experience the ultimate visual impact of Midjourney on 微鲤AI!',

      // Core Features
      coreFeaturesTitle: 'Midjourney Core Features',
      coreFeaturesSubtitle: 'Explore the powerful features of Midjourney and start your professional AI image creation journey',

      feature1Title: 'Precise Text Rendering',
      feature1Desc: 'Significantly improved ability to generate accurate text in images. By wrapping text in double quotes (" "), the model can generate correctly spelled titles, neon signs, or labels with font styles that perfectly blend with the image, solving the pain point of AI struggling with specific characters.',
      feature1Alt: 'Midjourney precise text rendering example',

      feature2Title: 'Hyperrealistic Portraits & Anatomical Correction',
      feature2Desc: 'Deep optimization for common hand and limb errors in AI painting. v6.1 can generate anatomically accurate fingers and limbs, and greatly enhanced skin texture realism, including pores, wrinkles, and subsurface scattering effects of light on skin, reaching commercial photography level.',
      feature2Alt: 'Midjourney hyperrealistic portrait example',

      feature3Title: 'Personalization Fine-tuning',
      feature3Desc: 'The model learns and builds a user-specific aesthetic model based on user history ratings and preferences. This means images generated by each person will carry their unique personal artistic style, rather than just generic "AI flavor".',
      feature3Alt: 'Midjourney personalization example',

      feature4Title: 'Intelligent Texture Enhancement & 2x Upscaling',
      feature4Desc: 'Equipped with new Subtle and Creative upscalers. While doubling the image resolution, the model intelligently adds small details that did not originally exist (such as fabric fibers, distant leaves), making 4K output possible without over-smoothing or artifacts.',
      feature4Alt: 'Midjourney intelligent upscaling example',

      // How to Use
      howToUseTitle: 'How to Use Midjourney on 微鲤AI',
      howToUseSubtitle: 'Get started in just three steps',

      step1Title: 'Select Model',
      step1Description: 'Choose Midjourney in the AI Image tools',

      step2Title: 'Enter Content',
      step2Description: 'Enter prompts or upload reference images',

      step3Title: 'Generate Image',
      step3Description: 'Click generate and download your image',

      // YouTube Section
      youtubeTitle: 'YouTube Videos About Midjourney AI Image Model',

      // X Posts Section
      xPostsTitle: 'X Posts About Midjourney AI Image Model',

      // Explore Models
      exploreModelsTitle: 'Explore Other Image Models on 微鲤AI',
      model1Title: 'Nano Banana Pro',
      model2Title: 'Seedream 4.5',
      model3Title: 'Dreamina 4',
      model4Title: 'Wan 2.5',

      // FAQ
      faqTitle: 'Frequently Asked Questions',

      faq1Question: 'What is Midjourney?',
      faq1Answer: 'Midjourney is recognized as one of the most comprehensive AI image generation models, renowned for its artistic composition, realistic lighting effects, and powerful detail expression.',

      faq2Question: 'What can it do?',
      faq2Answer: 'It can generate photo-realistic images, illustrations in various styles, game assets, web design materials, and in v6.1, the ability to generate images with text and maintain character consistency has been greatly improved.',

      faq3Question: 'Is it free to use on 微鲤AI?',
      faq3Answer: 'Midjourney official service is fully paid. On 微鲤AI, we offer limited free trial credits. For high-frequency use or commercial generation, we recommend subscribing to our membership plan for more stable access.',

      faq4Question: 'What is the image quality?',
      faq4Answer: 'Extremely high quality. Midjourney generates 1024x1024 resolution by default, and through its built-in Upscaler, can output 2048x2048 or higher HD images with rich details and no blur.',

      faq5Question: 'How is it different from Wan AI or Seedream 4.5?',
      faq5Answer: 'Compared to models like Wan AI or Seedream 4.5, Midjourney greatest advantage is its ultimate artistic aesthetics and lighting quality. While Seedream is more precise in multi-image consistency control and Nano Banana Pro is faster, Midjourney can directly generate images with cinematic composition, rich details, and strong visual impact without complex prompts, making it the first choice for high-quality artistic creation.',

      faq6Question: 'Can I use generated images commercially?',
      faq6Answer: 'If you are a paid subscriber of 微鲤AI, you typically have commercial usage rights for generated images. Please refer to 微鲤AI terms of service for details.',

      // CTA Section
      ctaTitle: 'Try Midjourney Now',
      ctaDescription: 'Use the top-tier AI image generation model for free',
      ctaButton: 'Start Creating',
      ctaDisclaimer: 'No credit card required',
      },
    nl: { // Dutch (copied from English)
      // SEO Meta
      pageTitle: 'Midjourney - Flexible, detailed and vibrant image generation',
      pageDescription: 'Midjourney is a flagship AI image model from an independent research lab, renowned for its artistic aesthetics and lighting quality. Try it free on 微鲤AI.',
      shortDescription: 'Flexible, detailed and vibrant image generation',
      pageKeywords: 'Midjourney, AI image generation, artistic creation, lighting quality, text rendering, hyperrealistic portraits, 微鲤AI',
      ogTitle: 'Midjourney AI Image Generator | 微鲤AI',
      ogDescription: 'Midjourney flagship AI image model with ultimate artistic aesthetics and lighting quality',
      twitterTitle: 'Midjourney - Flexible, detailed and vibrant image generation',
      twitterDescription: 'Experience Midjourney powerful image generation with ultimate artistic sense and detail expression',

      // Generator Section
      generatorTitle: 'Midjourney Image Generator',
      generatorSubtitle: 'Midjourney is the latest generation flagship AI image model from independent research lab Midjourney Inc. While maintaining industry-leading artistry and lighting quality, it has significantly improved image coherence, anatomical accuracy of limbs, and text rendering capabilities. The model is renowned for its nuanced understanding of natural language, realistic skin texture rendering, and unique personalization fine-tuning features, making it the preferred tool for digital artists, photographers, and high-end design professionals worldwide. Experience the ultimate visual impact of Midjourney on 微鲤AI!',

      // Core Features
      coreFeaturesTitle: 'Midjourney Core Features',
      coreFeaturesSubtitle: 'Explore the powerful features of Midjourney and start your professional AI image creation journey',

      feature1Title: 'Precise Text Rendering',
      feature1Desc: 'Significantly improved ability to generate accurate text in images. By wrapping text in double quotes (" "), the model can generate correctly spelled titles, neon signs, or labels with font styles that perfectly blend with the image, solving the pain point of AI struggling with specific characters.',
      feature1Alt: 'Midjourney precise text rendering example',

      feature2Title: 'Hyperrealistic Portraits & Anatomical Correction',
      feature2Desc: 'Deep optimization for common hand and limb errors in AI painting. v6.1 can generate anatomically accurate fingers and limbs, and greatly enhanced skin texture realism, including pores, wrinkles, and subsurface scattering effects of light on skin, reaching commercial photography level.',
      feature2Alt: 'Midjourney hyperrealistic portrait example',

      feature3Title: 'Personalization Fine-tuning',
      feature3Desc: 'The model learns and builds a user-specific aesthetic model based on user history ratings and preferences. This means images generated by each person will carry their unique personal artistic style, rather than just generic "AI flavor".',
      feature3Alt: 'Midjourney personalization example',

      feature4Title: 'Intelligent Texture Enhancement & 2x Upscaling',
      feature4Desc: 'Equipped with new Subtle and Creative upscalers. While doubling the image resolution, the model intelligently adds small details that did not originally exist (such as fabric fibers, distant leaves), making 4K output possible without over-smoothing or artifacts.',
      feature4Alt: 'Midjourney intelligent upscaling example',

      // How to Use
      howToUseTitle: 'How to Use Midjourney on 微鲤AI',
      howToUseSubtitle: 'Get started in just three steps',

      step1Title: 'Select Model',
      step1Description: 'Choose Midjourney in the AI Image tools',

      step2Title: 'Enter Content',
      step2Description: 'Enter prompts or upload reference images',

      step3Title: 'Generate Image',
      step3Description: 'Click generate and download your image',

      // YouTube Section
      youtubeTitle: 'YouTube Videos About Midjourney AI Image Model',

      // X Posts Section
      xPostsTitle: 'X Posts About Midjourney AI Image Model',

      // Explore Models
      exploreModelsTitle: 'Explore Other Image Models on 微鲤AI',
      model1Title: 'Nano Banana Pro',
      model2Title: 'Seedream 4.5',
      model3Title: 'Dreamina 4',
      model4Title: 'Wan 2.5',

      // FAQ
      faqTitle: 'Frequently Asked Questions',

      faq1Question: 'What is Midjourney?',
      faq1Answer: 'Midjourney is recognized as one of the most comprehensive AI image generation models, renowned for its artistic composition, realistic lighting effects, and powerful detail expression.',

      faq2Question: 'What can it do?',
      faq2Answer: 'It can generate photo-realistic images, illustrations in various styles, game assets, web design materials, and in v6.1, the ability to generate images with text and maintain character consistency has been greatly improved.',

      faq3Question: 'Is it free to use on 微鲤AI?',
      faq3Answer: 'Midjourney official service is fully paid. On 微鲤AI, we offer limited free trial credits. For high-frequency use or commercial generation, we recommend subscribing to our membership plan for more stable access.',

      faq4Question: 'What is the image quality?',
      faq4Answer: 'Extremely high quality. Midjourney generates 1024x1024 resolution by default, and through its built-in Upscaler, can output 2048x2048 or higher HD images with rich details and no blur.',

      faq5Question: 'How is it different from Wan AI or Seedream 4.5?',
      faq5Answer: 'Compared to models like Wan AI or Seedream 4.5, Midjourney greatest advantage is its ultimate artistic aesthetics and lighting quality. While Seedream is more precise in multi-image consistency control and Nano Banana Pro is faster, Midjourney can directly generate images with cinematic composition, rich details, and strong visual impact without complex prompts, making it the first choice for high-quality artistic creation.',

      faq6Question: 'Can I use generated images commercially?',
      faq6Answer: 'If you are a paid subscriber of 微鲤AI, you typically have commercial usage rights for generated images. Please refer to 微鲤AI terms of service for details.',

      // CTA Section
      ctaTitle: 'Try Midjourney Now',
      ctaDescription: 'Use the top-tier AI image generation model for free',
      ctaButton: 'Start Creating',
      ctaDisclaimer: 'No credit card required',
      },
    id: { // Indonesian (copied from English)
      // SEO Meta
      pageTitle: 'Midjourney - Flexible, detailed and vibrant image generation',
      pageDescription: 'Midjourney is a flagship AI image model from an independent research lab, renowned for its artistic aesthetics and lighting quality. Try it free on 微鲤AI.',
      shortDescription: 'Flexible, detailed and vibrant image generation',
      pageKeywords: 'Midjourney, AI image generation, artistic creation, lighting quality, text rendering, hyperrealistic portraits, 微鲤AI',
      ogTitle: 'Midjourney AI Image Generator | 微鲤AI',
      ogDescription: 'Midjourney flagship AI image model with ultimate artistic aesthetics and lighting quality',
      twitterTitle: 'Midjourney - Flexible, detailed and vibrant image generation',
      twitterDescription: 'Experience Midjourney powerful image generation with ultimate artistic sense and detail expression',

      // Generator Section
      generatorTitle: 'Midjourney Image Generator',
      generatorSubtitle: 'Midjourney is the latest generation flagship AI image model from independent research lab Midjourney Inc. While maintaining industry-leading artistry and lighting quality, it has significantly improved image coherence, anatomical accuracy of limbs, and text rendering capabilities. The model is renowned for its nuanced understanding of natural language, realistic skin texture rendering, and unique personalization fine-tuning features, making it the preferred tool for digital artists, photographers, and high-end design professionals worldwide. Experience the ultimate visual impact of Midjourney on 微鲤AI!',

      // Core Features
      coreFeaturesTitle: 'Midjourney Core Features',
      coreFeaturesSubtitle: 'Explore the powerful features of Midjourney and start your professional AI image creation journey',

      feature1Title: 'Precise Text Rendering',
      feature1Desc: 'Significantly improved ability to generate accurate text in images. By wrapping text in double quotes (" "), the model can generate correctly spelled titles, neon signs, or labels with font styles that perfectly blend with the image, solving the pain point of AI struggling with specific characters.',
      feature1Alt: 'Midjourney precise text rendering example',

      feature2Title: 'Hyperrealistic Portraits & Anatomical Correction',
      feature2Desc: 'Deep optimization for common hand and limb errors in AI painting. v6.1 can generate anatomically accurate fingers and limbs, and greatly enhanced skin texture realism, including pores, wrinkles, and subsurface scattering effects of light on skin, reaching commercial photography level.',
      feature2Alt: 'Midjourney hyperrealistic portrait example',

      feature3Title: 'Personalization Fine-tuning',
      feature3Desc: 'The model learns and builds a user-specific aesthetic model based on user history ratings and preferences. This means images generated by each person will carry their unique personal artistic style, rather than just generic "AI flavor".',
      feature3Alt: 'Midjourney personalization example',

      feature4Title: 'Intelligent Texture Enhancement & 2x Upscaling',
      feature4Desc: 'Equipped with new Subtle and Creative upscalers. While doubling the image resolution, the model intelligently adds small details that did not originally exist (such as fabric fibers, distant leaves), making 4K output possible without over-smoothing or artifacts.',
      feature4Alt: 'Midjourney intelligent upscaling example',

      // How to Use
      howToUseTitle: 'How to Use Midjourney on 微鲤AI',
      howToUseSubtitle: 'Get started in just three steps',

      step1Title: 'Select Model',
      step1Description: 'Choose Midjourney in the AI Image tools',

      step2Title: 'Enter Content',
      step2Description: 'Enter prompts or upload reference images',

      step3Title: 'Generate Image',
      step3Description: 'Click generate and download your image',

      // YouTube Section
      youtubeTitle: 'YouTube Videos About Midjourney AI Image Model',

      // X Posts Section
      xPostsTitle: 'X Posts About Midjourney AI Image Model',

      // Explore Models
      exploreModelsTitle: 'Explore Other Image Models on 微鲤AI',
      model1Title: 'Nano Banana Pro',
      model2Title: 'Seedream 4.5',
      model3Title: 'Dreamina 4',
      model4Title: 'Wan 2.5',

      // FAQ
      faqTitle: 'Frequently Asked Questions',

      faq1Question: 'What is Midjourney?',
      faq1Answer: 'Midjourney is recognized as one of the most comprehensive AI image generation models, renowned for its artistic composition, realistic lighting effects, and powerful detail expression.',

      faq2Question: 'What can it do?',
      faq2Answer: 'It can generate photo-realistic images, illustrations in various styles, game assets, web design materials, and in v6.1, the ability to generate images with text and maintain character consistency has been greatly improved.',

      faq3Question: 'Is it free to use on 微鲤AI?',
      faq3Answer: 'Midjourney official service is fully paid. On 微鲤AI, we offer limited free trial credits. For high-frequency use or commercial generation, we recommend subscribing to our membership plan for more stable access.',

      faq4Question: 'What is the image quality?',
      faq4Answer: 'Extremely high quality. Midjourney generates 1024x1024 resolution by default, and through its built-in Upscaler, can output 2048x2048 or higher HD images with rich details and no blur.',

      faq5Question: 'How is it different from Wan AI or Seedream 4.5?',
      faq5Answer: 'Compared to models like Wan AI or Seedream 4.5, Midjourney greatest advantage is its ultimate artistic aesthetics and lighting quality. While Seedream is more precise in multi-image consistency control and Nano Banana Pro is faster, Midjourney can directly generate images with cinematic composition, rich details, and strong visual impact without complex prompts, making it the first choice for high-quality artistic creation.',

      faq6Question: 'Can I use generated images commercially?',
      faq6Answer: 'If you are a paid subscriber of 微鲤AI, you typically have commercial usage rights for generated images. Please refer to 微鲤AI terms of service for details.',

      // CTA Section
      ctaTitle: 'Try Midjourney Now',
      ctaDescription: 'Use the top-tier AI image generation model for free',
      ctaButton: 'Start Creating',
      ctaDisclaimer: 'No credit card required',
      },
    tr: { // Turkish (copied from English)
      // SEO Meta
      pageTitle: 'Midjourney - Flexible, detailed and vibrant image generation',
      pageDescription: 'Midjourney is a flagship AI image model from an independent research lab, renowned for its artistic aesthetics and lighting quality. Try it free on 微鲤AI.',
      shortDescription: 'Flexible, detailed and vibrant image generation',
      pageKeywords: 'Midjourney, AI image generation, artistic creation, lighting quality, text rendering, hyperrealistic portraits, 微鲤AI',
      ogTitle: 'Midjourney AI Image Generator | 微鲤AI',
      ogDescription: 'Midjourney flagship AI image model with ultimate artistic aesthetics and lighting quality',
      twitterTitle: 'Midjourney - Flexible, detailed and vibrant image generation',
      twitterDescription: 'Experience Midjourney powerful image generation with ultimate artistic sense and detail expression',

      // Generator Section
      generatorTitle: 'Midjourney Image Generator',
      generatorSubtitle: 'Midjourney is the latest generation flagship AI image model from independent research lab Midjourney Inc. While maintaining industry-leading artistry and lighting quality, it has significantly improved image coherence, anatomical accuracy of limbs, and text rendering capabilities. The model is renowned for its nuanced understanding of natural language, realistic skin texture rendering, and unique personalization fine-tuning features, making it the preferred tool for digital artists, photographers, and high-end design professionals worldwide. Experience the ultimate visual impact of Midjourney on 微鲤AI!',

      // Core Features
      coreFeaturesTitle: 'Midjourney Core Features',
      coreFeaturesSubtitle: 'Explore the powerful features of Midjourney and start your professional AI image creation journey',

      feature1Title: 'Precise Text Rendering',
      feature1Desc: 'Significantly improved ability to generate accurate text in images. By wrapping text in double quotes (" "), the model can generate correctly spelled titles, neon signs, or labels with font styles that perfectly blend with the image, solving the pain point of AI struggling with specific characters.',
      feature1Alt: 'Midjourney precise text rendering example',

      feature2Title: 'Hyperrealistic Portraits & Anatomical Correction',
      feature2Desc: 'Deep optimization for common hand and limb errors in AI painting. v6.1 can generate anatomically accurate fingers and limbs, and greatly enhanced skin texture realism, including pores, wrinkles, and subsurface scattering effects of light on skin, reaching commercial photography level.',
      feature2Alt: 'Midjourney hyperrealistic portrait example',

      feature3Title: 'Personalization Fine-tuning',
      feature3Desc: 'The model learns and builds a user-specific aesthetic model based on user history ratings and preferences. This means images generated by each person will carry their unique personal artistic style, rather than just generic "AI flavor".',
      feature3Alt: 'Midjourney personalization example',

      feature4Title: 'Intelligent Texture Enhancement & 2x Upscaling',
      feature4Desc: 'Equipped with new Subtle and Creative upscalers. While doubling the image resolution, the model intelligently adds small details that did not originally exist (such as fabric fibers, distant leaves), making 4K output possible without over-smoothing or artifacts.',
      feature4Alt: 'Midjourney intelligent upscaling example',

      // How to Use
      howToUseTitle: 'How to Use Midjourney on 微鲤AI',
      howToUseSubtitle: 'Get started in just three steps',

      step1Title: 'Select Model',
      step1Description: 'Choose Midjourney in the AI Image tools',

      step2Title: 'Enter Content',
      step2Description: 'Enter prompts or upload reference images',

      step3Title: 'Generate Image',
      step3Description: 'Click generate and download your image',

      // YouTube Section
      youtubeTitle: 'YouTube Videos About Midjourney AI Image Model',

      // X Posts Section
      xPostsTitle: 'X Posts About Midjourney AI Image Model',

      // Explore Models
      exploreModelsTitle: 'Explore Other Image Models on 微鲤AI',
      model1Title: 'Nano Banana Pro',
      model2Title: 'Seedream 4.5',
      model3Title: 'Dreamina 4',
      model4Title: 'Wan 2.5',

      // FAQ
      faqTitle: 'Frequently Asked Questions',

      faq1Question: 'What is Midjourney?',
      faq1Answer: 'Midjourney is recognized as one of the most comprehensive AI image generation models, renowned for its artistic composition, realistic lighting effects, and powerful detail expression.',

      faq2Question: 'What can it do?',
      faq2Answer: 'It can generate photo-realistic images, illustrations in various styles, game assets, web design materials, and in v6.1, the ability to generate images with text and maintain character consistency has been greatly improved.',

      faq3Question: 'Is it free to use on 微鲤AI?',
      faq3Answer: 'Midjourney official service is fully paid. On 微鲤AI, we offer limited free trial credits. For high-frequency use or commercial generation, we recommend subscribing to our membership plan for more stable access.',

      faq4Question: 'What is the image quality?',
      faq4Answer: 'Extremely high quality. Midjourney generates 1024x1024 resolution by default, and through its built-in Upscaler, can output 2048x2048 or higher HD images with rich details and no blur.',

      faq5Question: 'How is it different from Wan AI or Seedream 4.5?',
      faq5Answer: 'Compared to models like Wan AI or Seedream 4.5, Midjourney greatest advantage is its ultimate artistic aesthetics and lighting quality. While Seedream is more precise in multi-image consistency control and Nano Banana Pro is faster, Midjourney can directly generate images with cinematic composition, rich details, and strong visual impact without complex prompts, making it the first choice for high-quality artistic creation.',

      faq6Question: 'Can I use generated images commercially?',
      faq6Answer: 'If you are a paid subscriber of 微鲤AI, you typically have commercial usage rights for generated images. Please refer to 微鲤AI terms of service for details.',

      // CTA Section
      ctaTitle: 'Try Midjourney Now',
      ctaDescription: 'Use the top-tier AI image generation model for free',
      ctaButton: 'Start Creating',
      ctaDisclaimer: 'No credit card required',
  },
}
